import { v4 as uuidv4 } from 'uuid'

/**
 * Builds the `telemetry` option passed into WebRTCSession.connect(). Lives outside lib/webrtc/lib
 * so it can reach the Vuex store and the API base URL without coupling the framework-agnostic
 * collector to them.
 *
 * Collection only runs when the connected device has "Video Diagnostics" enabled
 * (joinData.webrtc_diagnostics_enabled). The emit transport always uses fetch with keepalive so
 * the payload survives a tab close while still carrying the Auth0 Bearer token (which sendBeacon
 * cannot attach). NOTE: when the API is cross-origin, the Authorization/Content-Type headers
 * force a CORS preflight; a preflight during page unload is not guaranteed to complete, so the
 * pagehide emit can be lost cross-origin. The 30s and session-end emits (page still alive) are
 * unaffected. Switch to navigator.sendBeacon (token in body) if reliable teardown delivery is
 * required.
 *
 * See design/webrtc-viewer-telemetry.md.
 *
 * @param {object} store - the Vuex store
 * @param {object} joinData - the join response payload
 * @param {{ camera: string }} opts - 'internal' | 'ptz'
 */
export function buildViewerTelemetryOptions(store, joinData, { camera }) {
  const url = `${import.meta.env.VITE_API_BASE_URL}/v1/videos/webrtc_telemetry`
  return {
    diagnosticsEnabled: joinData.webrtc_diagnostics_enabled === true,
    sessionId: store.state.uniqueSessionId,
    telemetryId: uuidv4(),
    camera,
    appVersion: import.meta.env.VITE_BUILD,
    emit: (payload) => {
      fetch(url, {
        method: 'POST',
        keepalive: true,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${store.state.token}`,
          'Session-Id': store.state.uniqueSessionId
        },
        body: JSON.stringify(payload)
      })
        .then(res => console.info(`[ViewerTelemetry] payload sent (HTTP ${res.status})`, { telemetry_id: payload.telemetry_id }))
        .catch(err => console.warn('[ViewerTelemetry] payload send failed', err)) // never surfaced to the call
    }
  }
}
